<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12">
				<h1 v-if="$vuetify.breakpoint.smAndUp" class="band-color-green interview-title">
					Day 1 - Tennessee
				</h1>
				<h1 v-else class="band-color-green interview-title-sm">
					Day 1 - Tennessee
				</h1>
			</v-col>
			<v-col cols="12">
				<p class="band-color-green word-salad">
					(The Human Zoo, Pajama Liar, Worst Boss Ever, Feed The Hole, Bear Traps, Invisible Hand of High Crimes, Waving At The Enemy, Carouselambra, Choke Berries, Free Money To Africa, That Old Ford, Brother Can You Spare A Dime, Developing Detection Tools, Nosey Neighbors, Sniffing Out Surveillance, Ricardo &amp; Smith Inc, Love Story, The Legacy Letter, Harassment Of Potential Donors, Rocky Top, Introducing The Spy King, Fitting In, Bird Bath, The Hills Have Eyes, Sin City, Tree Falling On My Life, The New Scarlet Letter A, Bear Country Jamboree, Moving To Tennessee, Splitting Cords, Into The Woods, Mickey Mouse, Welcome To The Filth, You’re Not In College Anymore, Dream Cabin, Insect Drone, Losing The War, Prehistoric Paradise, Forties Funk, Financial Breakdown, Minority Report, Talk Of The Town, Winter, Nobody Runs Here, Prototypes In Paradise, A Dangerous Deception, Nicotina, I Thought You Were Special, Red Velvet, Rattling My Cage, Take The Long Way Home, Terrifying Trees, Peddling Produce, You Look Familiar, Speaking With Billionaires, Deer In The Headlights, Sunset People, Grandma Says, An Unusual Alliance, Camouflage, Leaving The Volunteer State, Careless Whispers, Welcome Home GOATS, Can't Tell Me Nothing and more… See Timeline for Chronology of Events)
				</p>
			</v-col>
			<v-col cols="12" class="interview-color main-text text-border">
				<p class="h-l">
						H.L. I find it interesting that you left out the word ‘abortion’ in the summary you gave me. Don’t you think that it should be included? Isn’t this at the core of the cover-up and scandal we are about to dig into?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Sure, and you’re right, but it has obviously taken on its own life and become something so distorted that it is hard to remember that this is where it all began. It all started out with a simple mistake in marketing so many years ago, children that are in school now, were not even thought of yet; my children.
						<span class="break"></span>
						If I was going to describe what this is really about, I don’t think I would use the word abortion; love story perhaps, but not abortion.
				</p>

				<p class="h-l">
						H.L. A love story? Are you sure?
				</p>
				<p>
						<span class="douglas">Douglas:</span> I am. Because at its core that’s what this is. It is a sick and twisted love story; one of unrequited love. It’s a love story where both you and I, and many others are victims.
				</p>
				<p class="h-l">
						H.L. I see your point.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Welcome to the filth of the human heart.
				</p>
				<p class="h-l">
						H.L. It should be quite a journey to the center of it.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, it should be.
				</p>
				<p class="h-l">
						H.L. Speaking of children, how many do you have?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Five children total; I have four sons and one daughter. Two of my sons are grown and live in the U.S., the other three children are younger and they live in Europe.
				</p>
				<p class="h-l">
						H. L. So how do you expect this interview to be received?
				</p>
				<p>
						<span class="douglas">Douglas:</span> I would guess that the first reaction would be disbelief, which I completely understand.
						<span class="break"></span>
						Perhaps those who know me might think, well, these are his interpretations of what occurred to him. Others will just be in complete denial of the events, or think I have some ulterior motive. I don’t really know.
				</p>

				<p class="h-l">
						H.L. You haven’t thought about it?
				</p>
				<p>
						<span class="douglas">Douglas:</span> No, I think about it a lot actually. We all want to be liked, you can’t escape it. As I have told you earlier, I am mildly terrified about the response.
						<span class="break"></span>
						Ascetics fear rejection the most, though they are the last to admit it. But this needs to come out. It needs to come out for many reasons.
				</p>

				<p class="h-l">
						H.L. Societal reasons?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes. I was at the bank the other day and the bank teller was talking about current politics and events and she said, “I know that someone is lying to us, but I am not sure who. All I know is that I am getting tired of it.” I really feel that’s the way most Americans feel right now and likely many people around the world as well.
						<span class="break"></span>
						And if you have information, regardless of what the repercussions are, you must deliver it. In a way, it’s like voting; you as a citizen are obligated. But for me, it is more than an obligation.
				</p>

				<p class="h-l">
						H.L. How is it more?
				</p>
				<p>
						<span class="douglas">Douglas:</span> It will be liberating. That is my feeling; I just can’t stand to keep it bottled up inside of me for another day longer. I mean, there is no one I can talk to it about, and writing it down only goes so far. I would just write and then stop and think to myself; no one is going to believe this, or else I feared I would come across as cocky, arrogant or worse.
				</p>
				<p class="h-l">
						H.L. Sounds like you were trying too hard. I know when I write and those feelings arise, especially on personal issues, this is the problem.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Sure, I think you are right. I know I was trying too hard to make something palatable to the reader that was not ever going to be palatable to begin with. It was a no-win situation.
						<span class="break"></span>
						Then, there was the problem of likeability. The deeper I took a look at these individuals, the more I began to empathize with them; the more I began to empathize with them, the more I liked them, and therefore became less effective with my narrative.
				</p>

				<p class="h-l">
						H.L. That makes sense. So you would have to remind yourself, “Hey these people have seriously impeded my life?”
				</p>
				<p>
						<span class="douglas">Douglas:</span> Exactly.
				</p>
				<p class="h-l">
						H.L. Do you take it personally; the events that have transpired in regards to the suppression of your work?
				</p>
				<p>
						<span class="douglas">Douglas:</span> I definitely try not to, but sometimes it really hurts. There were times in Tennessee where I was really angry. Should I begin to explain the events?
				</p>
				<p class="h-l">
						H.L.  Sounds about the right time to start.
				</p>
				<p>
						<span class="douglas">Douglas:</span> So, The Theorem (<span class="italic">The Theorem: A Complete Answer to Human Behavior</span>) came out in 2006. I will skip over 8 years of drifting around the world aimlessly; maybe we could talk about that part later.
				</p>
				<p class="h-l">
						H.L. That’s fine, so we are in 2014?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Actually late 2013. You know when I first made the discovery that would lead to The Theorem all the way back in 1994, my family was supportive of my efforts and excited about what I had found. At the same time, they also felt this discovery was larger than something I was capable of accomplishing on my own.
						<span class="break"></span>
						They wanted me to reach out for help. They come from another era; they felt that if I could only get a celebrity to endorse the discovery and book, then I would be on my way.
				</p>

				<p class="h-l">
						H.L. And you didn’t agree?
				</p>
				<p>
						<span class="douglas">Douglas:</span> I thought that was simplistic. Besides, the celebrities I had met while working in Las Vegas over the years were somewhat fragile; they were very talented, but fragile.
				</p>
				<p class="h-l">
						H.L. The artistic temperament?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Very true. So I just ignored my family’s advice and tried to do everything myself. Besides, so many people had been hurt by The Theorem; I didn’t want anyone else’s life to be ruined.
				</p>
				<p class="h-l">
						H.L. You didn’t want any celebrities to get hurt? I think they are grown-up people and can make that decision for themselves.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Do you know how many times I have heard that?
				</p>
				<p class="h-l">
						H.L. No.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Well, too many times. I have heard that from so many people over the years, and some very strong people as well, but it always ends up the same. With them telling me, “I didn’t know it was going to be like this!”
						<span class="break"></span>
						This discovery just has a certain type of energy to it, one that plows through so many people and so many lives. You will learn just how accurate this statement is over the next week, or however long this takes us.
				</p>

				<p class="h-l">
						H.L. So you didn’t think the artistic temperament was the right choice? Is this an attempt to be noble?
				</p>
				<p>
						<span class="douglas">Douglas:</span> More practical. I didn’t want some Hollywood starlet walking head on into traffic on Sunset Boulevard because she lost her perfume contract after endorsing such a controversial book. I wasn’t going to be responsible for that.
				</p>
				<p class="h-l">
						H.L. But as you told me earlier, many celebrities did get hurt from this anyways.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Well yes, but that was almost completely out of my control.
						<span class="break"></span>
						At the same time many celebrities were elevated way beyond where they deserved to be because of this. It all depended on how the liberal hierarchy in Hollywood saw you to begin with, but now we’re jumping ahead, days ahead. Can I continue with the events?
				</p>

				<p class="h-l">
						H.L. Yes. Go ahead.
				</p>
				<p>
						<span class="douglas">Douglas:</span> So it’s late 2013, winter was coming; I think it was October or early November. I had been working hard, saving money and The Theorem had been on the market for close to six years.
						<span class="break"></span>
						The book was out of print and I talked my publisher into releasing the rights back to me. I knew I had to do something, as I had come too far to turn back. I knew I needed financial help to get the marketing going.
				</p>

				<p class="h-l">
						H.L. Why not just look for another publisher?
				</p>
				<p>
						<span class="douglas">Douglas:</span> That’s a very good question, and as you would imagine it was one I was asked often, back then especially. The problem was that by 2013, I knew what the publishing business was all about. While I had written a scathing critique of my previous publisher, over time I began to understand his actions. You know, he would say that a publisher publishes a lot of books. If I give this book, The Theorem, the attention it deserves then all the other books and all the other authors would be neglected. And it was true.
						<span class="break"></span>
						So I just felt it would be better to market the discovery in another way. Now, in what way that was? I had no idea, but I knew I needed money, and a lot of it to undertake this project.
				</p>

				<p class="h-l">
						H.L. So you decided to write to the billionaires.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, but we are jumping ahead a bit. You see I wasn’t even sure that I was going to write to anyone. I was also seriously considering starting another book and just shelving The Theorem temporarily. In fact, I think that is what those around me wanted me to do.
				</p>
				<p class="h-l">
						H.L. So you were not alone?
				</p>
				<p>
						<span class="douglas">Douglas:</span> No, I was not alone, not at all. I had two friends with me. But I will not go into details about them; I care about them and don’t want them to get involved in this anymore than they already were. I would like to protect their privacy. I hope you understand.
						<span class="break"></span>
						Though they certainly helped me come out of whatever funk I was in; I will always be grateful for that. We made the best of a bad time and traveled and lived internationally together for an extended length of time. But that is another story altogether.
				</p>

				<p class="h-l">
						H.L.  Sure. So why did you choose to write billionaires?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Another good question. I can’t say exactly. I certainly knew nothing about billionaires. Truthfully, I don’t even think that I knew at the time what an actual billionaire was, in terms of how much money.
						<span class="break"></span>
						In many ways it was as though I had been living in a cave, mentally speaking. I wasn’t just out of touch with the wealthy class; I was out of touch with everyone!
						<span class="break"></span>
						The reasons I chose billionaires? Well, in a convoluted way I guess it makes sense.
				</p>
				<p class="h-l">
						H.L. What do you mean by that exactly?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Well, as I told you literature was always my first love, Russian Literature. I always figured I would teach World Literature as a professor somewhere. But my second love was economics. As a kid and into my teens I would read about the great leaders in economic thought; Smith, Ricardo, Marx, Malthus and many more. I loved economics, primarily macroeconomic theory.
				</p>
				<p class="h-l">
						H.L. The Invisible Hand?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, Adam Smiths’ ‘Invisible Hand’ and more, so contacting wealthy individuals was not a stretch.
						<span class="break"></span>
						Also during my early twenties, I was in a situation where my wife at the time was pregnant, and I had no employment opportunities of any significance. So, I started a small produce company in California. I started it out of the back of my father’s pickup truck, which I borrowed; the company grew very quickly and soon I had many large refrigerated trucks and a large number of employees. I did so well that my father was able to take a leave of absence from his job and come to work for me.
						<span class="break"></span>
						While the company ultimately failed, the time I had with my father, outside of the typical dynamic of a father and son relationship, were some of the best times in my life. So I had a positive perception of business, and the concepts related to it.
				</p>

				<p class="h-l">
						H.L. A different dynamic; meaning you were his boss?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, and I was not a very nice boss at all. But my father used the format of my business to teach me so much about life and about how to treat people. I learned so much. I miss him deeply.
				</p>
				<p class="h-l">
						H.L. So your father had passed away, you said this was a few years previous to 2014. Do you think you were looking for a father figure, or a replacement?
				</p>
				<p>
						<span class="douglas">Douglas:</span> You know looking back that makes sense. But at the time I didn’t see it. I am sure that most psychologists would agree with your assessment.
						<span class="break"></span>
						Perhaps that is true, because I know I had a great amount of confidence when I drafted <span class="italic">The Legacy Letter</span>.
						<span class="break"></span>
						Actually think you are onto something there, because sometimes when I would read it, while I was sending it, I would say to myself, “How gutsy, the things you say; these are great men and you’re writing to them as though they’re your younger brother. Who the hell do you think you are?”
				</p>

				<p class="h-l">
						H.L. You could do that because your father was your employee, well that is interesting.
				</p>
				<p>
						<span class="douglas">Douglas:</span> I think so.
				</p>
				<p class="h-l">
						H.L. Do you think all of these experiences helped you when drafting <span class="italic">The Legacy Letter</span>?
				</p>
				<p>
						<span class="douglas">Douglas:</span> I would say so, yes. Because when I first drafted <span class="italic">The Legacy Letter</span>, I knew I was onto something special.
						<span class="break"></span>
						It’s hard to explain, but you just get that feeling that radiates inside and you realize: This is what it is all about! That was how I felt right away. I truly believed in the words that I was writing, and had earned them. That is important. You have to earn the words, or people will see right through you, no matter what types of words they are.
				</p>

				<p class="h-l">
						H.L. The letter is impressive certainly. Explain to those who might not know, what was in it?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Thank you. Yes, well first I introduced myself. I explained that I had accidentally made one of the largest discoveries in human psychology. I let them know I was nervous about writing to them; I explained that there was an attachment, and let them know inside the attachment was quite a lengthy letter. I showed that I had respect for their time, and recommended they read it during their off time or a time more convenient for them.
						<span class="break"></span>
						I asked them to return to a place in time in their life when the odds were stacked against them, where they only had a dream; to see themselves in the letter that way, as they were reading it.
						<span class="break"></span>
						Then I spoke of immortality and legacy and explained things, which I will not disclose, things that only someone who has made the largest discovery in human psychology would know about. This was to let them know that I was for real.
				</p>

				<p class="h-l">
						H.L.  So you knew right away it was going to be good.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, but I am uncomfortable talking about it too much. You see, it was personal, for me and for them. In fact, I had planned that no one would ever know about this entire ordeal. I am a very private person and they are very private people; we share the same interest in discretion.
						<span class="break"></span>
						But unfortunately, I have no choice but to share this because of the governmental actions.
				</p>

				<p class="h-l">
						H.L. The government used this confidentiality against you; against them?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Sure they did. I was the common denominator in all their prosecutions. I could clearly see the pattern. They would come to my website; have a large number of reads of <span class="italic">The Legacy Letter</span>, or make phone calls to me and then it would happen.
						<span class="break"></span>
						But we are getting way ahead of ourselves. Can I tell you about the cabin, because it is impossible to explain the events without the cabin?
				</p>

				<p class="h-l">
						H.L. Yes, you seem very proud of the cabin. You can tell about that.
				</p>
				<p>
						<span class="douglas">Douglas:</span> I was proud of it. The cabin was quite the talk around my family at the time. As a writer, I was very much used to writing in dumps; places that you prefer to forget. But this cabin, the one we lived in when we moved to Tennessee in the fall of 2013, was special; and again, important to the narrative we will be unraveling.
				</p>
				<p class="h-l">
						H.L. It was in Gatlinburg, Tennessee you said? That is a beautiful place.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, actually it was about 2 or 3 miles outside of Gatlinburg, and it was stunning! The area where we lived however could have been a hundred miles from any town because the people there were very rural and self-contained. This wasn’t a touristy part of Gatlinburg at all.
				</p>
				<p class="h-l">
						H.L. Everyone knew everyone.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, everyone knew everyone and every single car that came up and down the road. This fact will be important later.
				</p>
				<p class="h-l">
						H.L. Did the locals and neighbors see you as an outsider; a threat?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Well that’s the funny thing. Of course, at first they did. We had a rental car and the biggest home in the neighborhood; essentially the mansion on the hill. So yes, at first they were very standoffish.
						<span class="break"></span>
						But we had spent too much money on getting into the place, as it was way over our budget; though, it was all that was available at the time. So we had to skimp on the vehicle we purchased. Therefore, we bought this very old and rundown Ford compact pickup truck for 400 dollars, complete with homemade wooden utility cabinets on both sides of the bed.
				</p>

				<p class="h-l">
						H.L. A real eyesore?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes definitely it was. The old truck was seriously ugly, and made us look impoverished (which of course we would soon be). To make matters worse or better, it blew a thick cloud of black smoke when we tried to climb the massive hill to get to our cabin.
				</p>
				<p class="h-l">
						H.L. Tried?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, tried. The cabin was tucked off the main street up a massive hill that was our driveway. It was a large and long enough grade that your ears would pop when you would go up and down it.
				</p>
				<p class="h-l">
						H.L. I find that hard to believe.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Well, maybe that is an exaggeration, but it was a massive grade and a very long, narrow driveway. So sometimes, if you if you weren’t going fast enough and didn’t get a good jump on it, you would stall halfway up; then you would have to back all the way down the hill and circle the neighborhood to get a running start up the hill again. This typically happened when all three of us were in the truck or when we had too many groceries. And that is not an exaggeration. It was a piece of junk!
				</p>
				<p class="h-l">
						H.L. So the neighbors then accepted you?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, they actually thought we were caretakers for the property; the vehicle didn’t fit in with the cabin. Plus, the utility box made it look like I was handy with tools, which was a complete joke, because I am clumsy with a hammer.
				</p>
				<p class="h-l">
						H.L. The cabin? You wanted to describe the cabin.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, the cabin shouldn’t have even been called a cabin; it was like a palace. It truly was in one of the most beautiful settings I have ever seen in my life.
						<span class="break"></span>
						The cabin was backed into the National Forest, and surrounded by a massive canopy of trees. There were ferns, bugs and vines that looked as though they were lifted right out of the prehistoric era; it was paradise.
						<span class="break"></span>
						The canopy of trees also covered the top of the cabin, so no sunlight came in nor light got out. This kept it cool in the summer, and actually warm in the winter.
				</p>

				<p class="h-l">
						H.L. Like a hideout?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, but the cabin was so very plush, and we were hiding from no one.
						<span class="break"></span>
						There were two hot tubs; one inside and one outside. We only used the inside hot tub though, because the outside tub belonged to the bears, so we couldn’t use that one.
						<span class="break"></span>
						In the main hallway was a red velvet pool table that was surrounded by massive glass windows. In fact, the entire wall was a wall of windows that overlooked the forest down the hill. So you were actually looking at a forested mural of tree branches; a living breathing mural.
						<span class="break"></span>
						The walls of the cabin were all natural logs with clear shellac; the logs were handpicked and cut by the original owner back in the 1940’s. This is the story at least, as it was conveyed to us. You could tell immediately though that a lot of love went into the building of this place. The only drawback was that there was just one bedroom. Again, it was a cabin, but it was large and had plenty of room. It just wasn’t functional or practical.
				</p>


				<p class="h-l">
						H.L. The bears?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, you can’t understand these events accurately without talking about the bears, as they are central to at least part of the narrative. I know we have a lot to cover; do you want to skip them for now?
				</p>
				<p class="h-l">
						H.L. Go ahead, if you feel they are necessary.
				</p>
				<p>
						<span class="douglas">Douglas:</span> As I said, the cabin backed up to the mountain. There was only one tiny path leading from the top of the mountain and through the massive forest down onto the main road. The main road ultimately led to the town.
						<span class="break"></span>
						Now the easiest and quietest way for the bears to get to the town was on this path, and this path backed up right into the side of our house. This was the bear path. It was more like a bear highway however. It would not be uncommon for us to see three or four bears a day walking through our yard, and hear at least seven or eight more at night.
						<span class="break"></span>
						Because it was an old cabin, it had no screens on the windows. So in the summer, if we had the windows open, the bigger bears would often poke their heads in on their way down to the town to raid the garbage cans; part of their nightly routine.
				</p>

				<p class="h-l">
						H.L. That’s wild. Were you scared?
				</p>
				<p>
						<span class="douglas">Douglas:</span> No, it wasn’t like that at all. While we never moved up there for the bears, it was an added bonus. I love bears and have been in the wild with them in Alaska and also near Yellowstone when I lived there. The bears in Tennessee however, were black bears, and they were really used to people. They knew the rules and we knew the rules.
				</p>
				<p class="h-l">
						H.L. They knew the rules, not to bother people?
				</p>
				<p>
						<span class="douglas">Douglas:</span> More like we knew the rule, the single rule: The place belonged to the bears; we were just visitors.
						<span class="break"></span>
						The only reason I bring up the bears at all here, is that they will play an important role later. You see, while we had no fear of the bears, those who would later undertake the physical surveillance of the cabin; the NSA, FBI or whatever governmental agency or subcontractor was responsible, were definitely weary of the bears and this would change the dynamic of the scenario. But now I am jumping ahead.
				</p>

				<p class="h-l">
						H. L. Getting back to the letter
				</p>
				<p>
						<span class="douglas">Douglas:</span> Sure, I know we have a long way to go; I just don’t want to leave anything out.
				</p>
				<p class="h-l">
						H.L. You seem saddened now. Is something wrong?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Well, it’s probably silly or stupid, but what they did to the bears wasn’t right. It still bothers me to this day.
				</p>
				<p class="h-l">
						H.L. I see. Since you will be talking about it later, let’s just move onto <span class="italic">The Legacy Letter</span>.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Sure, you’re right.
						<span class="break"></span>
						So I started sending the letter out at the beginning of February, 2014. At first it was very silent. I mean, really silent. It took a while to learn how to get the emails through the various bots that would kick them into spam. Now, I was hand customizing each copy of <span class="italic">The Legacy Letter</span> into email form.
						<span class="break"></span>
						So that took even longer. I know that there are programs that will do it for you, but I felt that these potential investors would know if I hadn’t taken the time and personal care to customize each one. After all, these were some of the richest men in the world. I really wanted to send the letters hard copy in the mail, but it was just too expensive. So I did what I could.
				</p>

				<p class="h-l">
						H.L.  Quality over quantity.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, but here was the problem, if you could call it that. When I would look up the information about these men, I would find myself reading their short biographies. Then I would become too interested in their stories, and look up more information about them.
				</p>
				<p class="h-l">
						H.L. This cut down your production?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, substantially. My two friends with me would ask me, “Hey, how many did you send out?” I would tell them, well, 40 or 50 letters. And they would be frustrated, but I couldn’t help it because when reading the stories of their early struggles, I was suddenly back in Las Vegas in 1994 and all those memories; great memories, life changing memories of making that discovery that would lead to The Theorem.
						<span class="break"></span>
						I was enthralled by the scenario, and I suppose by them.
				</p>

				<p class="h-l">
						H.L. Do you think they felt the same way?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Actually, yes I do. I think in a big way that’s what was happening. You see, at the time, I had a personal website up. The website was very wordy, and very long. In there, I described my life and the discovery in extensive detail.
						<span class="break"></span>
						But these billionaires would read my biographical information on my website and I think it wasn’t so much about my story, but it brought them back to that time in their life when they were young. I think I was more of a symbol. Of course, I saw them the same way.
				</p>

				<p class="h-l">
						H.L. Sounds like a recipe for a friendship.
				</p>
				<p>
						<span class="douglas">Douglas:</span> I think you are right, because there was always something more there than just that exchange. I could feel it, and see it, but only now am I able to define it. I really looked on them as friends, more than potential investors. I think that is where the problems started.
				</p>
				<p class="h-l">
						H.L. You mean problems with the phone calls?
				</p>
				<p>
						<span class="douglas">Douglas:</span> That, and problems with the government. I had hit a nerve with some of the most powerful men in the world, and when you do that, then the government is naturally going to take notice.
						<span class="break"></span>
						I was so naïve though. I can’t explain to you how naïve I was. This just wasn’t anything I ever saw coming; not in a hundred years could I have seen it. I was as clueless as the deer in our backyard, and the bears were on their way down for dinner. I just didn’t know it yet.
				</p>

				<p class="h-l">
						H.L. I can see that.
				</p>
				<p>
						<span class="douglas">Douglas:</span> After awhile, I was finally able to get into a rhythm in sending out <span class="italic">The Legacy Letter</span>. I would send the letters out, and put tracking on the emails to see if they were reading them.
						<span class="break"></span>
						At this early stage, seeing evidence that they were reading the letter was all the motivation I had to keep me going. Since there were only so many business hours during the day in the U.S., after hours I would send them to the wealthy elite in countries that were open during those hours.
				</p>

				<p class="h-l">
						H.L. So you would view the number of times the potential investors would read the email and this kept you going?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes exactly. In the evening I sent the letter out primarily to Asia and Oceania; mostly India and Australia. In many ways, it was as though I was addicted to seeing how many times the email had been read; it was kind of pathetic really. In the early morning or very late at night, I would also send <span class="italic">The Legacy Letter</span> out to Europe, as these were the hours of their normal day to day operations.
				</p>
				<p class="h-l">
						H.L. Then the phone calls started?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, well it took awhile. But yes, they started. The first thing to understand about the phone calls is that I was never prepared for them. I just never thought anyone would call me, nor did any part of the letter encourage it.
						<span class="break"></span>
						True, I put my phone number on <span class="italic">The Legacy Letter</span>, but that was for identification purposes. I wanted them to know it was me. I figured, the more information I could provide for them to authenticate my identity, the more likely they would be to invest or donate. I just never expected them to call me. So not being prepared really was a problem.
				</p>

				<p class="h-l">
						H.L. You said you didn’t do well on the phone calls, when the billionaires began calling you?
				</p>
				<p>
						<span class="douglas">Douglas:</span> That is an understatement for sure. I choked! There is simply no other way to describe it. I really did. I could not find my words. I became nervous and forgot what I was going to say. It was really bad.
						<span class="break"></span>
						While I felt like I knew each one of them, after reading their biographical profiles, I would forget everything the minute they would call me. It’s embarrassing to this day.
						<span class="break"></span>
						This all happened in a short period of a few weeks in the late spring of 2014. They were calling and I was blowing leads left and right.
						Often times they would ask me, “How much do you need?”
				</p>

				<p class="h-l">
						H.L.   Really? They asked you how much money you needed.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, I was that close. All I had to do was give them an amount and carry on a coherent conversation, and The Theorem would be a household name; I just couldn’t get the words out of my mouth. Or else, I would pick some ridiculously low amount of money, like $20,000 dollars. I mean, they spend that much on lunch.
						<span class="break"></span>
						They expected me; I am sure, to have a substantial budget in the hundreds of thousands of dollars. I was just in way over my head; way out of my league.
				</p>

				<p class="h-l">
						H.L. I think a lot of people would be nervous when speaking with billionaires, especially if you are not prepared.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Ah, but that was no excuse. I just really choked. It wasn’t like I was a shy person either. I was experienced at public speaking. I was even the captain of the debate team in college.
				</p>
				<p class="h-l">
						H.L. But this wasn’t college.
				</p>
				<p>
						<span class="douglas">Douglas:</span> No. This wasn’t college, it was for keeps. You know there are two things I have learned about billionaires, and that is this: First, they know right away if you like them or not, and most definitely I liked them, this was obvious. So I passed the first test.
						<span class="break"></span>
						The second is that they instinctively know if you are ready for the money or not. They just know it.
				</p>

				<p class="h-l">
						H.L. Don’t you think they are ever fooled, I imagine they sometimes invest or loan money to people who aren’t ready for it.
				</p>
				<p>
						<span class="douglas">Douglas:</span> I think that there are many wealthy individuals out there with 50 or 100 million dollars who get fooled, who haven’t developed those instincts or at least refined them.
						<span class="break"></span>
						But I think once you cross that threshold into billionaire status, all of that is behind you. I think there are ‘tells’ hardly noticeable to others, they pick up on. They rarely mess up at that level. They just realized I wasn’t ready.
						<span class="break"></span>
						Again, it is a very embarrassing chapter for me.
				</p>

				<p class="h-l">
						H.L. So what did you do then?
				</p>
				<p>
						<span class="douglas">Douglas:</span> All I could do. I started calling them instead; as you would imagine, I didn’t do any better, nor did I even get much more convincing at it. But I had to call, if nothing else, to save face with my friends who were around me.
				</p>
				<p class="h-l">
						H.L. They were disappointed as well?
				</p>
				<p>
						<span class="douglas">Douglas:</span> They were shocked mostly. They had never seen me like that. They were used to a very strong and brave man. We had traveled together to some very dangerous places in the world. I had gotten us out of some big jams. I had a lot of confidence, and this was a big blow to their opinion of me. So I didn’t give up. I couldn’t!
						<span class="break"></span>
						At the same time, at this point, I began to retreat away and into myself; kind of in the corner. At least until I could come up with a solution.  So, I decided to send out packages and draft another letter. The problem was I didn’t know who to send them to. And this is when I started the process of learning how to interpret the data regarding who was coming to my website.
				</p>

				<p class="h-l">
						H.L. Tell me about that.
				</p>
				<p>
						<span class="douglas">Douglas:</span> By now I had sent out many copies of <span class="italic">The Legacy Letter</span>, perhaps even a thousand. While I told you about the phone calls, after a while everything became really silent, like it dropped off a cliff.
				</p>
				<p class="h-l">
						H.L. When was this?
				</p>
				<p>
						<span class="douglas">Douglas:</span> You know it’s hard to remember exactly, but I think around the earliest part of summer in 2014. It was as though I suddenly became invisible. Really everyone just stopped; no phone calls, no replies and no real interest.
				</p>
				<p class="h-l">
						H.L. Is this when you believe the government suppression efforts were beginning?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, but of course I know that now, but at the time I really had no idea.
						<span class="break"></span>
						No, instead I blamed myself completely. I figured that word had gone around that I wasn’t ready for the money, or that this entire project was a flop or whatever.
						So by early summer, maybe even late spring of 2014, I had already sent out almost a thousand copies of <span class="italic">The Legacy Letter</span>, and I had only enough money to send out maybe 50 follow-up letters and potential donor packages in the mail. Therefore, it was necessary to find out who was interested. Now looking back, I should have focused exclusively on those who I had talked to on the phone, but I did not.
						<span class="break"></span>
						I wanted fresh leads, I guess somehow reasoning that this time I wouldn’t screw things up when I talked to them.
				</p>

				<p class="h-l">
						H.L. That seems rational.
				</p>
				<p>
						<span class="douglas">Douglas:</span> The problem was that detecting who was interested was nearly impossible. These billionaires had some of the most secure browsers to mask their searches, so all the data was scrambled. Obviously it makes sense because millions, if not billions, of dollars were at stake for them, so they had to be able to browse in complete privacy. They are very secretive; it was a challenge.
				</p>
				<p class="h-l">
						H.L. But you did it.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, but it took awhile; at least a few months. The thing is that I am very good at seeing patterns, at seeing things that other people do not see. So I had an advantage.
				</p>
				<p class="h-l">
						H.L. Like when you made the discovery for The Theorem?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Exactly, just like that. Though at the time I felt what I was doing was much more trivial than neuroscience; this web detection technique I was developing. Though now I realize it was not. As witnessed by the content of this narrative.
						<span class="break"></span>
						I just have a certain gift that way. It’s strange really, but then in exchange for that, there are other areas where my brain shuts down, and I can’t accomplish the simplest of things.
				</p>

				<p class="h-l">
						H.L. Simple things like what?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Like tying my shoes. I struggle with keeping the laces tied in my boots, and have for twenty years. It’s ridiculous.
				</p>
				<p class="h-l">
						H.L. That’s funny. But you saw patterns?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, what I did was figure out how to use other websites that they visited and turn those websites into actual search engines so I could see who was visiting them. Again, this took some time, and many websites did not work this way; so it was trial and error.
				</p>
				<p class="h-l">
						H.L. I think the big question or reservation for any one reading this would be, what if they go to those websites you were using for a search engine with their identity concealed or masked? Then certainly your method of detection would not work.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Well that is what you would think. That is what I thought as well. But it is not necessarily true. Here’s why. Let’s say I am John Doe and I am a CEO of a company and I want to go to a website that ranks my standings or gives information about me as a CEO. I go there masked, so they don’t know I am coming. I do this over six months. So now, the website knows it is me when I am coming even though my search is blocked.
				</p>
				<p class="h-l">
						H.L. How?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Because who is looking up John Doe the most over a long period of time?
				</p>
				<p class="h-l">
						H.L. John Doe.
				</p>
				<p>
						<span class="douglas">Douglas:</span> While there are exceptions, for the most part no one really is going to look up themselves more consistently over a long period of time than they are. All of us are our biggest fan in a way.
						<span class="break"></span>
						But it was more than that, as the crawlers and bots collect data from the internet which a server then combines to develop a profile of every individual. They mine data from those in the executive’s office, maybe their secretary who is not masked in their search; or his executive assistant on their smart phone on the way home; maybe the physical location or whatever. All of this metadata is then compiled to form a profile.
				</p>

				<p class="h-l">
						H.L. This profile is used by advertisers to target the market?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, and as you know, millions, if not billions, of dollars is spent on this information; it’s developed by programmers that are very talented. But the information is there; it’s public but you will never be able to see it unless you know how to interpret it. I had the ability to look at it backwards, and there were massive holes I could see from that angle.
						<span class="break"></span>
						You know about it. I have shown you how it works.
				</p>

				<p class="h-l">
						H.L.  It’s remarkable. It really is, I can’t believe that others didn’t see it or know how to use it. You said the search engines did not like it when you would do that?
				</p>
				<p>
						<span class="douglas">Douglas:</span> No, they hated it. They were always detecting me as a bot, or a crawler or whatever. So I had to be patient and careful, or they would block my efforts.
						<span class="break"></span>
						I really need to explain something though; I need to clarify that this was not hacking at all. I mean, I would never attempt to go to any of these potential investor’s sites and mine information that way. I just don’t believe in doing that. I value my privacy and knew they valued theirs.
						<span class="break"></span>
						The truth is that I wouldn’t know the first thing about hacking like that anyways. And even if I had learned how to do that, they would not be the people you would want to try and obtain information from; as I imagine their data is locked down beyond any skill set I would ever develop. What I was doing was all public access.
				</p>

				<p class="h-l">
						H.L. But you said that you had a coder with web developing skills that lived with you at the time.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, but again that was just coincidental and that person was never directly involved in my detection efforts.
						<span class="break"></span>
						However, I will say that this person being there gave me confidence, and I would learn things just by having conversations with them. But no, they were never directly involved.
						<span class="break"></span>
						You see, the thing is, I had other advantages as well. For example, I had not done any marketing of The Theorem for years. Therefore, my website had essentially no traffic whatsoever. So, I was almost starting with a blank slate. I doubt that by that time barely over 1000 people had read The Theorem. And if you spread out a 1000 people over many years, this isn’t much web traffic.
						<span class="break"></span>
						Then, when I started marketing The Theorem with <span class="italic">The Legacy Letter</span>, I only sent them to people who had high visibility on the web. So they would float to the top of my visibility list. This, in contrast to someone who had little written about them; those people you could never find with this method.
				</p>

				<p class="h-l">
						H.L.  This is when you found out that the government was prosecuting people who were interested in the letter, in your book?
				</p>
				<p>
						<span class="douglas">Douglas:</span> No, that was later. At this point, I had not a clue. Honestly, I was so wrapped up in the newfound vanity of realizing that these prominent individuals were reading what I had written and were interested; I really couldn’t think of anything else.
						<span class="break"></span>
						You have to imagine that by this time in my life, in that situation, I was really beat down as a man. I mean, I was at the bottom. There wasn’t much left of me at all.
						<span class="break"></span>
						I had been through an extremely painful divorce. My wife kept the kids and stayed in Europe. I hadn’t seen them in years. I was absolutely devastated. The book was a flop. My life was in shambles.
				</p>

				<p class="h-l">
						H.L. That’s tough. So anything positive was welcomed.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, I absolutely needed this boost of confidence.
						<span class="break"></span>
						To make matters worse, as I told you, I had just failed miserably at my phone conversations with the billionaires. So my failures weren’t far away in some distant place like Holland, in some distant time, they were right there next to me. I couldn’t pretend or masquerade that I was going to be a success at some other time, because the proof was right there in front of me. I had failed those around me. I was humiliated, embarrassed and shrunk into nothing.
				</p>

				<p class="h-l">
						H.L. So the attention was more than welcomed, it was a lifesaver?
				</p>
				<p>
						<span class="douglas">Douglas:</span> I really think so. I became somewhat obsessed with finding the names behind the visitors who were coming to my website. Those around me didn’t know what to make of it, as I was now extremely focused on this.
						<span class="break"></span>
						Here, for once in so many years, I had the first evidence that what I was doing was working. Truthfully, it had been over eight years since I had anything positive in my life. Eight years!
				</p>
				<p class="h-l">
						H.L. That’s a long time.
				</p>
				<p>
						<span class="douglas">Douglas:</span> It is. But now I had hope. And hope was something I very much needed.
						<span class="break"></span>
						You know, man can endure a lot. He can survive minutes without air, days without water and weeks without food, but a second without hope is hell on earth.
				</p>

				<p class="h-l">
						H.L. Well said. So you knew then, you saw evidence that <span class="italic">The Legacy Letter</span> was successful?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, I knew right away. It was a huge hit. I was very proud. Here, I could track the traffic of the letter and the word of mouth that followed it. Really, it was such an eye opener.
						<span class="break"></span>
						While I believed that the letter was special when I had written it, here I saw the proof.
						<span class="break"></span>
						It would typically work like this: I would send it to a billionaire; he would then forward or talk about it with a few of his friends, either other billionaires or those with very high net worth themselves. Now if it was in a foreign country it was different.
						<span class="break"></span>
						You see many of these foreign billionaires are close friends to the ruling party; the government, The King, or The Prime Minister. So then the ruling party would find out about it and from there, it went down to the celebrities in the country and then back to the billionaires. I was amazed. This was really making waves!
				</p>
				<p class="h-l">
						H.L. You’re smiling, this obviously brought you some happiness.
				</p>
				<p>
						<span class="douglas">Douglas:</span> That’s it, real happiness. Even remembering it makes me smile.
						<span class="break"></span>
						But it was more than that. When I had written The Theorem, I had written it with the general reader in mind. I was young and paranoid and was sure the medical community would rip me off, so I wanted to get the message out to the common man and woman; to the common reader. That was fine, but the common man has his limitations.
				</p>

				<p class="h-l">
						H.L.  Limitations? Please be more specific.
				</p>
				<p>
						<span class="douglas">Douglas:</span> It is hard to explain, but they lack self-confidence. Somebody would read The Theorem or hear about it and get really excited. Then they would go tell their friends or family and it would always end the same.
						<span class="break"></span>
						Someone, somewhere down the information line would be like a brick wall. They would get to someone in their circle who was negative, a naysayer who would shoot their excitement down. The naysayer would have no confidence, and therefore believe that nothing this important would happen to them, and especially as conveyed to them by person who told them about it.
						<span class="break"></span>
						To the person who was excited about the book it was like a condemnation of their value as a messenger, more than the value of The Theorem. Still, it slowed the process down. There was always that wall with the common man; it was just too much for him to accept.
				</p>

				<p class="h-l">
						H.L. But not with the wealthy and powerful? That sounds elitist.
				</p>
				<p>
						<span class="douglas">Douglas:</span> No not with them; not with the wealthy at all.
						<span class="break"></span>
						But I am not putting down the common man. I only know this because I earned this knowledge the hard way. I was, and I am one of those common people. You see when I first made the discovery I knew it was right, immediately! I had not a single doubt. The entire experience bordered on the surreal, the supernatural.
						<span class="break"></span>
						But what happens when the common man experiences something so impossible?
				</p>

				<p class="h-l">
						H.L. I don’t know.
				</p>
				<p>
						<span class="douglas">Douglas:</span> He doubts.
						<span class="break"></span>
						I spent ten years trying to disprove it. I could have put out a solid book in three years, maybe even two, but I wasted seven years lost in myself; consumed in my own doubts. And when I did try and put a draft out within the first couple of years, I destroyed it with sabotage.
						<span class="break"></span>
						Like so many people I thought great discoveries only happened in some other place, safely tucked away in the past. As though the minute the discovery touched my hands it would dilute in importance. I was a victim to my own lack of self-esteem, of self-belief and importance in the world.
				</p>

				<p class="h-l">
						H.L. Yes, but don’t you think that this is part of the discovery process? Einstein spent many years trying to disprove his own theories.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, and what a waste of time. Really it is sad.
						<span class="break"></span>
						But you see with these people, the wealthy, they didn’t suffer from this low self- esteem.
				</p>

				<p class="h-l">
						H.L. That sounds naïve, idealistic.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Actually, you’re right. That’s not what I wanted to say.
						<span class="break"></span>
						What I was trying to say, I guess, is that maybe many wealthy people do suffer from self-esteem issues; the fact however that the wealthy individuals were receiving the information from someone above them economically, the billionaires, negated some of those doubts.
						<span class="break"></span>
						The chain of information never hit a brick wall, it just kept flowing!
				</p>

				<p class="h-l">
						H.L. That makes more sense.
				</p>
				<p>
						<span class="douglas">Douglas:</span> It is just much more believable to realize that somebody else has accomplished what was once considered impossible if you have done it yourself. I think that is how the billionaires experienced it, and that was a significant part of the content of <span class="italic">The Legacy Letter</span>.
				</p>
				<p class="h-l">
						H.L. So you felt your book had finally found its market?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Well yes, in a way; and eight years too late. But that wasn’t my primary interest at the time.
				</p>
				<p class="h-l">
						H.L. Okay, just trying to process this all. You go up to the Tennessee Mountains, you decide to write wealthy individuals for assistance; the letter is a big success, but you don’t know it yet.
						<br />
						Then the billionaires call you on the phone, you do poorly with this, and therefore do not get the money. Then you develop a method to detect who is coming to your website and realize the letter is a success after all.
				</p>

				<p>
						<span class="douglas">Douglas:</span> Yes.
				</p>
				<p class="h-l">
						H.L. And this is all happening within a few months. It sounds like a lot to get crammed into a short time.
				</p>
				<p>
						<span class="douglas">Douglas:</span> It was. And listening to you synopsize it makes me realize how quick and prolific these changes were in my life. It is a time in your life, and I am sure you have experienced it, when the days are endless: one day sneaks into another, and you lose all track of time; where years of growth are compacted into weeks or months. This is what was happening.
						<span class="break"></span>
						I was experiencing a lot of different things at one time. I was realizing my limitations as a man. I was realizing my ineffectiveness in some aspects of my life, while underestimating my talents in another. All of this under the canopy of the forest; under the canopy of a tremendous, ominous feeling of failure and of heartbreak in missing my children, and of the obligation to the friends I had around me at the time.
				</p>

				<p class="h-l">
						H.L. Sounds like a carousel.
				</p>
				<p>
						<span class="douglas">Douglas:</span> More like a roller coaster. Or maybe a merry-go-round, the ones we used to spin on as kids, where you go so fast that we would almost pass out from the g-force. This was all occurring in a short compact time of six months. At that point, I was definitely starting to spin.
				</p>
				<p class="h-l">
						H.L Continue.
				</p>
				<p>
						<span class="douglas">Douglas:</span> To add to the chaos, I also inherited a whole other group of problems.
				</p>
				<p class="h-l">
						H.L. Problems like what?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Like who to exclude and who not to exclude. It seemed like the wealthy friends of the billionaires were more interested in the book or coming to The Theorem Website more often than the actual people I sent the letter to. It was as though they did not want to be excluded, and they were waiting for their copy of <span class="italic">The Legacy Letter</span>.
						<span class="break"></span>
						After all, these are very powerful men, and this is a big discovery. And these guys work very hard to make sure they will never be excluded.
						<span class="break"></span>
						So I didn’t want to bruise any egos. I quickly realized that I could make powerful enemies on accident, if I didn’t get them their copy of the letter.
				</p>

				<p class="h-l">
						H.L. That’s a good point. I never thought of that. I suppose it comes with the territory.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yeah, it was a problem I hadn’t anticipated either; I essentially was trapped by my own success, the convincing clarity of <span class="italic">The Legacy Letter</span>.
						<span class="break"></span>
						Yet I was not successful at all in achieving my original goal. So of course I kept emailing. I was originally only going to send out 100 copies and be done in 3 months. I ended up sending out 10,000 copies and it took almost 3 years!
						<span class="break"></span>
						So word got out. The book became popular, but another problem was that I was not receiving any money from the book and I didn’t have any copies just sitting around in boxes or anything. I am just not that way.
				</p>

				<p class="h-l">
						H.L. No, you were living like a gypsy, always moving. It would have been hard to have a box of books with you.
				</p>
				<p>
						<span class="douglas">Douglas:</span> So when they would ask for a copy of the book, I would have to purchase it like anyone else. Now, at first that was no big deal. Copies of The Theorem were cheap, even the new ones were less than 30 dollars; but as the marketing intensified and the popularity of the book increased…
				</p>
				<p class="h-l">
						H.L. So did the price of the book.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, sometimes it was as high as 500.00 or even 1000.00 dollars! I could not even afford to buy my own book. It was bizarre. And there was no way I could send these billionaires a used copy, they would just throw that in the trash can. It would be an insult.
						<span class="break"></span>
						So I had to do a lot of tap dancing and stalling, some never received their copy. Things were falling apart quickly. I needed money to continue the process of trying to get money. It was bad.
						<span class="break"></span>
						And to make matters worse...
				</p>

				<p class="h-l">
						H.L. That is when you noticed the government was prosecuting and harassing your people?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, this is when I noticed it.
						<span class="break"></span>
						But it wasn’t an all at once realization.
						<span class="break"></span>
						I think the best analogy I can give is when you realize that you have a mouse or mice in your home. At first you see a flash out of the corner of your eye. You tell yourself, it must be an optical illusion, so you dismiss it. Then it happens again, only now the mouse is moving a little slower and you can clearly see its tail as it runs under the counter.
						<span class="break"></span>
						Then a third time and you see the entire mouse. But you do nothing, you’re in denial. At least in my case, I would be. I hate the idea of killing a mammal, so I would just ignore it, and tell myself next time I see it again then I would get out the traps.
						<span class="break"></span>
						Well, before you know it, the mice are sitting there watching the television with you! They are all over the place.
				</p>

				<p class="h-l">
						H.L. That’s so true. Explain.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Well, one morning it all hit me. But before that, I was starting to see patterns. I was starting to piece together the fact that those who showed the most interest in <span class="italic">The Legacy Letter</span> and The Theorem seemed to be getting into a lot of trouble with the government. I would even say out loud, “Boy do these guys live some type of risky lifestyle. They are real high rollers!”
				</p>
				<p class="h-l">
						H.L. Sure, you didn’t want to make a direct connection back to you, but still you noticed a pattern.
				</p>
				<p>
						<span class="douglas">Douglas:</span> So on this particular morning, I was noticing the news of another prosecution or harassment of one of my potential investors or donor on the internet. I looked at the computer and looked down and saw a white van, bear traps, and then a jogger who I had seen before. Unfortunately where I had seen him before was in Central America, and then I looked back at the events on my computer.
						<span class="break"></span>
						Then I knew what was going on. It was another big blow. Now I will explain why seeing this individual who looked identical to an agent or operative in Central America was of significance, later. But at that moment, I knew.
				</p>

				<p class="h-l">
						H.L. That’s interesting, so you were seeing proof on your search, then that was contrasted with the physical surveillance, and together it surpassed the chance of coincidence. Correct?
				</p>
				<p>
						<span class="douglas">Douglas:</span>  Yes, but you have to realize though that there were two distinct waves of surveillance, which differ red in quality to the extreme.
						<span class="break"></span>
						First, when I would notice a strange vehicle, or someone taking pictures of the house, I would actually get excited. I would assume it was the billionaires who had hired private investigators to undertake surveillance to verify my identity. I figured this was a necessary first step before investing or donating.
				</p>

				<p class="h-l">
						H.L. Sure.
				</p>
				<p>
						<span class="douglas">Douglas:</span> So it was obvious we were being watched, and the neighbors knew it too. But again, I was excited and would even wave at them. Looking back, I feel so stupid at the thought of waving; how naïve I was.
				</p>
				<p class="h-l">
						H.L. That is sensible though. You don’t want to assume the worst.
				</p>
				<p>
						<span class="douglas">Douglas:</span> No, and again, I was very idealistic and I just wanted to be optimistic.
						<span class="break"></span>
						Well the first group of surveillance was sloppy; I knew it wasn’t the government. I mean, it wasn’t the government directly. It was more of a private security force, who did not quite have their act together. Looking back, I now know exactly who was responsible for the first wave of surveillance, and we will get into that over the coming days. But at the time I was quite confused.
				</p>

				<p class="h-l">
						H.L. This is comparable to seeing the tail of the mouse running under the cupboard?
				</p>
				<p>
						<span class="douglas">Douglas:</span> That’s funny, but yes, that’s exactly how it was. The people in the neighborhood were not amused; in fact, they were bothered because they knew this surveillance was there for us. After all, they knew every single car that came up and down that street. Many of these people had lived there for generations; you could not fool them. So tensions were arising with the neighbors. Then, everything went bad when the bear traps started showing up.
				</p>
				<p class="h-l">
						H.L. Would you explain the relevance of the bear traps?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, of course. At first we were befuddled at their purpose and presence. Eventually, we figured out the obvious. The bear traps were there to remove the bears so that surveillance teams would be willing to go into the forest surrounding our house.
				</p>
				<p class="h-l">
						H.L. The neighbors didn’t like the bear traps?
				</p>
				<p>
						<span class="douglas">Douglas:</span> No, they didn’t because again they knew everyone, and everyone’s behavior, including the bears. So they figured that the only reason the traps would show up is if we called and complained; which of course we would never do, as we loved the bears. But to the people in the neighborhood, it had to be us. Now that changed later.
						<span class="break"></span>
						And again, the whole trap ordeal was so very sad for the bears.
				</p>
				<p class="h-l">
						H.L. The bears couldn’t understand what they did wrong?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Exactly. Bears are highly intelligent mammals, and these bears were smarter than most. They had peacefully coexisted with the rural people there for generations. It was passed down through their very DNA on how to deal with the local residents. So this was a shock to them.
						<span class="break"></span>
						They knew the rules and they knew that if they broke them they would be punished.  Like the time, according to the neighbors, six years before when a bear chased one of their dogs. Well, then, the traps came out. The bears knew they had broken the rules, and life went on. But this time they had done nothing wrong. Again not only were the bears smart, but often old and wise, some were close to 30 years old.
						<span class="break"></span>
						So it was very sad indeed. The bears would just all congregate at the end of our driveway and sit there dumbfounded. They did not know what to do, whether to go down to the town or go back up into the mountains. This was a big deal in the neighborhood.
				</p>

				<p class="h-l">
						H.L. I imagine. Did they ever capture any bears?
				</p>
				<p>
						<span class="douglas">Douglas:</span> No I don’t think so, these bears were too smart.
						<span class="break"></span>
						But here is what happened. Because all the neighbors were complaining about the traps, they had to make up a false narrative; with live actors.
				</p>

				<p class="h-l">
						H.L.  What?
				</p>
				<p>
						<span class="douglas">Douglas:</span> I am serious. You can’t make this stuff up.
						<span class="break"></span>
						Here’s what happened: Next to us, and below was an old rental cabin that no one ever used; and I mean never. Well one day, someone with a new pickup pulled up to that cabin in the morning.
						<span class="break"></span>
						In about an hour, after he had changed into pajamas he came walking up to the top of the hill, where I was out in our front yard smoking a cigarette. He informed me to beware of the bears, he said they had broken into his truck last night and smashed the window. Well, I knew he had not spent the night there. So just to catch him in a lie, I walked down to survey the damage. When not knowing how to react, he changed his story to that the bears had almost broken his window, but instead left scratches on the truck.
						<span class="break"></span>
						Again, there were no scratches. He looked like a government employee, possibly FBI, NSA, or some other agency. Of course that afternoon another bear trap was there, right in that exact spot; right next to our house!
				</p>

				<p class="h-l">
						H.L. So they wanted all the bears gone?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, that’s where the physical description of the house comes into play. There was just no way they could undertake any type of surveillance there.
						<span class="break"></span>
						The roof was covered in a canopy of trees, so aerial surveillance was out. There was no high vantage point from which they could look into the house. We would have seen them coming in the day if they attempted to place any devices, as during the day one of us was almost always home.
						<span class="break"></span>
						And at night, no one would go up there and place the devices because it too dangerous, due to the bears. That’s why they tried to eliminate them. But it didn’t work. So finally they gave up on that and went to something else altogether, something much more sinister and technical.
				</p>

				<p class="h-l">
						H.L. Yes you told me about that. It’s hard to comprehend; go ahead, please describe it.
				</p>
				<p>
						<span class="douglas">Douglas:</span> You see at first, like I said, it wasn’t Obama undertaking the surveillance.
						<span class="break"></span>
						It looked like a rag tag bunch of special force washouts; the tail of the mouse as you referred to. These guys didn’t scare anyone. They were five pounds too heavy in the waistline, and about six ounces too light in the head. Most of the men in the neighborhood were strong, big guys; we all could hand split 5 or 6 cords of wood a day, even if they were face cords. So nobody was intimidated.
				</p>

				<p class="h-l">
						H.L. That’s funny, so they were sloppy.
				</p>
				<p>
						<span class="douglas">Douglas:</span> But when the President took over surveillance it was a different story. Whatever I describe about Barack Obama in this interview I will have to give him credit for one thing; he was the surveillance king.
				</p>
				<p class="h-l">
						H.L. All hail to the Surveillance King!
				</p>
				<p>
						<span class="douglas">Douglas:</span> He really was.  Everything was perfect, as this was his specialty. And I should know because I have witnessed it first hand; on the wrong side of it since he came into office in 2008. Essentially if you saw his guys, it was because they wanted you to see them. Sometimes they would make a mistake, but it was just so rare.
						<span class="break"></span>
						There was no margin for error. The neighbors and even the bears took notice when his team arrived, and stopped coming out.
				</p>

				<p class="h-l">
						H.L. Who the bears or the neighbors?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Both.
						<span class="break"></span>
						It was just a different feeling altogether. The vehicles were newer, the agents were much more in shape and the tools of surveillance, as I told you were state of the art.
				</p>

				<p class="h-l">
						H.L. You said earlier that you had seen one of these agents in Central America? How could that be?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, I know it was him too. I will never forget that haircut, his appearance, everything. Except in Central America he was with a group of other men who had to be Special Forces or Navy Seals or some elite branch of the military. I will explain that over the next few days.
						<span class="break"></span>
						In addition, you have to realize that the fact he was jogging there in our neighborhood was so impossibly rare. I jog all over the place, all over the world, and there was no way I ever went for a jog when I lived there in that cabin. You just didn’t want to run ever; a bear would see you and assume you were fleeing prey and that would be it. Everyone knew that. We would walk, but the hills and the terrain were so steep it was only out of necessity.
						<span class="break"></span>
						So yes I believe, that the presidents’ team, the secret NSA team he had earlier assigned to protect me in Central America, was back; at least one member of it.
				</p>

				<p class="h-l">
						H.L.  And the other. You said about the state of the art equipment.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Well fortunately I was not alone when that happened. I was not even the first one to notice it, and I am glad I wasn’t because no one would have believed me. Still the whole event defies belief.
						<span class="break"></span>
						It was close to summer of 2014, maybe even it was summer. I only know this because I had moved my work station from the main, glass-windowed hallway into the large open living room area where it was cooler.
						<span class="break"></span>
						I was sitting right under a window and the window was open. There were no screens, as I said. It was in the afternoon and my friend was sitting next to me. I have no idea what my friend was doing, because I was deep into concentration of interpreting data on my computer. I would not look up.
						<span class="break"></span>
						Then my friend told me to look at the window. Now the wooden table I was sitting on was right under the window. I looked at it and saw that a bumble bee had landed there, maybe a foot away from me on the edge of the table. I didn’t think anything of it, I just said, oh yeah, “It’s a bumble bee.” I realized it had just flown in the open window. My friend said no, it’s not. By now I was bothered and said okay it’s a carpenter bee, I don’t know!
				</p>

				<p class="h-l">
						H.L. Sure, you were working.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Then I took another look at it. At the same moment my friend said, “No, you don’t understand that’s not an insect. That’s a machine!” And my friend was right, because I sat there almost frozen and stared at it.
						<span class="break"></span>
						I suppose it was a miniature drone, or a prototype of some sort. It was perfectly disguised; really perfect. Only its action was mechanical. It would scan its head around the room; I imagine taking pictures or something. To this day I do not know if it had broken down or temporarily lost its signal, which was my guess and still is. The other option is that it was intentional, and that we were supposed to see it.
				</p>

				<p class="h-l">
						H.L.  That is something. Then what happened?
				</p>
				<p>
						<span class="douglas">Douglas:</span> It just flew off, and according to my friend it took the exact same route it had used when coming in. I thought I saw it again a few weeks later, but I can’t be sure because it looked identical to the real bees in the area; though later I am somewhat convinced that they had a drone in the tree disguised as a bird. This bird-like drone acted mechanical and would not go near the bird bath like the other birds.
						<span class="break"></span>
						These are just some of the things that occurred up there, the list goes on and on. But most of this, it seeps immediately into your subconscious, and only later; often times, years later when you feel safe can you reach it. It is how the human brain works.
				</p>

				<p class="h-l">
						H.L. That is some kind of experience you guys had up there; almost traumatizing. Briefly please, tell me a little more about how you realized the administration was targeting your potential investors.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Sure there is just one more thing about the insect drone, I wanted to say. Do we have space?
				</p>
				<p class="h-l">
						H.L. Yeah, go ahead.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Well after that event, realizing at what lengths President Obama would go to in order to gain surveillance and information, it made me accept something.
						<span class="break"></span>
						It became clear as to why President George W. Bush could not get Bin Laden and Obama could. I mean George W. Bush, whatever you say about him, is a very Christian man. And if his guys came back with surveillance of pictures of my friend and her 13 year-old daughter in their bedroom, even accidently taken by a bumblebee drone, they would have been immediately fired; maybe even jailed.
						<span class="break"></span>
						Obama’s team however, they didn’t care; whatever it took to get the intelligence! It was almost a sick form of surveillance voyeurism. Effective maybe, but sick definitely. I am disgusted by the whole ordeal, and have so much anger when reviewing this stuff.
				</p>

				<p class="h-l">
						H.L. That is sick. Do you need a break?
				</p>
				<p>
						<span class="douglas">Douglas:</span> No I’m alright; it is just like you said ‘compressed events’. Then later, the emotions that were compressed or suppressed hit you. Sometimes the emotions are good; other times, like this, they are tragic but they are always suppressed.
						<span class="break"></span>
						I will pull it together. So where were we?
				</p>

				<p class="h-l">
						H.L. You were going to explain a little more about how you could identify how they were prosecuting your potential investors.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Okay yes, that’s right. I can better explain it by example.
				</p>
				<p class="h-l">
						H.L. Go ahead.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Did you ever see that movie, <span class="italic bold">Minority Report</span> with Tom Cruise back in 2002?
				</p>
				<p class="h-l">
						H.L. Sure, it was a great movie; Spielberg and Cruise what a combination! They should do a sequel.
						<span class="break"></span>
						But what does that have to do with your situation?
				</p>

				<p>
						<span class="douglas">Douglas:</span> Well in the movie, if you remember; anyways I will just summarize it quickly for those who did not see it.
						<span class="break"></span>
						In the movie Tom Cruise plays a drug-addicted cop in the future and he works for an organization called PRECrime. And through the utilization of the three Precogs (Precogs in the movie were three people of special psychic ability laying in a pool with sensors attached to them) they actually predict crime before it ever happened. Then Tom Cruise would go arrest the criminal before they ever committed the crime.
				</p>

				<p class="h-l">
						H.L. Yes, I remember, it was a great movie as I said.
				</p>
				<p>
						<span class="douglas">Douglas:</span> So I bring that up because this is what it was like in my situation.
						<span class="break"></span>
						Someone would come to my website, heavily, and then three weeks to a month later, they would ‘commit a crime’ or at least be charged with one; typically a securities violation, tax issues or even more serious offenses. No matter, the end result was that the reputation they had worked so hard to cultivate would be ruined. I could not believe it. But it was definitely happening, over and over again.
						<span class="break"></span>
						At first, like seeing the mouse run across the floor, I lived in total denial. I would just lie to myself because I did not want to be responsible. But I really liked these potential investors and donors I sent <span class="italic">The Legacy Letter</span> to; I even considered some of them my friends. I was devastated! It is just so painful. To think and realize what they have done to me, to these people. I can’t believe I let it happen.
				</p>

				<p class="h-l">
						H.L. That’s okay take your time, no rush.
				</p>
				<p>
						<span class="douglas">Douglas:</span> I know that the pain makes me ramble on, and makes me avoid getting into the facts. It just is so much, for so long.
				</p>
				<p class="h-l">
						H.L. It needs to come out. Let it go.
				</p>
				<p>
						<span class="douglas">Douglas:</span> It is just so fucked up! I mean if you were there, and you could have seen what I saw. These sons of bitches had such smirks on their faces, it was sadistic. It was like they enjoyed it so much. It was so sick. You could just tell that Obama had complete contempt for those in the financial community. He enjoyed this.
						<span class="break"></span>
						The thing was that not a single one of these victims probably had any idea why it happened to them. The executives that they charged with the crimes seemed to be carefully chosen not to have close affiliations with other executives that were being charged. So they could not compare notes.
						<span class="break"></span>
						Many to this day probably have no idea that it was because they went to The Theorem’s website too much, or whispered to their wife, “Hey, I am going to help out a struggling writer and theorist who wrote me this heartfelt letter,”
						<span class="break"></span>
						Then tomorrow he wakes up and the FBI are at his door. It’s just so wrong, what a mess!
				</p>

				<p class="h-l">
						H.L. And you feel responsible?
				</p>
				<p>
						<span class="douglas">Douglas:</span> I am responsible! I mean what other way is there to say it? I screwed up. I should have stopped it.
				</p>
				<p class="h-l">
						H.L Yes, but you didn’t prosecute them; it was out of your hands.
				</p>
				<p>
						<span class="douglas">Douglas:</span> I should have stopped it. I should have picked up the phone like a man and called the president and said stop this shit, or I will expose you! But I just cowered. I will never forgive myself for that, never.
				</p>
				<p class="h-l">
						H.L. You can’t do this. You can’t put the weight of the world on your shoulders like this. It doesn’t work that way. If it wasn’t you it would have been someone else. You might not be the solution, but you’re not the problem either.
						<span class="break"></span>
						Besides, this should help. This will help you, I can see that.
				</p>

				<p>
						<span class="douglas">Douglas:</span> It is just that I was the common denominator to all these harassments. That is why they will do anything to keep this from coming out. You know they can erase the data, I know they likely already have done that. They can wash and scrub the emails, and everything, but they can’t kill everyone. I mean we are talking about close to twenty cases at least that I know about. There were more, I am sure; the real number, the ones I don’t know about are probably closer to forty or fifty cases total. At least in some form or another.
						<span class="break"></span>
						My hope is that those charged or harassed by the Obama administration will look back, all of them and remember and review those events before they were charged. If they can backtrack to those events, and come forward all of them, or even a few. This has all got to come out.
						<span class="break"></span>
						It was really like a nightmare of <span class="italic">no-effect</span> that I described in The Theorem. You are kicking and punching out at an opponent or a villain and your punches are powerless. That was how it felt to watch my newfound friends getting charged with bogus crimes; their reputations being torn to shreds, and I could do nothing about it. I am so sorry.
				</p>

				<p class="h-l">
						H.L.  Don’t blame yourself. Really don’t. Is there anything else you want to add before we wrap this up for the day?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Just give me a second here.
						<span class="break"></span>
						Well, I should probably talk about it. You know what I told you earlier.
				</p>

				<p class="h-l">
						H.L. You don’t have too. Not now, if you are not in any condition to do so. We can cover it later.
				</p>
				<p>
						<span class="douglas">Douglas:</span> No, I’m fine, I really am. It is just uncorking a few deep emotions. I will not be like this the rest of the week, I promise.
						<span class="break"></span>
						Let’s get it over with.
				</p>
				<p class="h-l">
						H.L. Okay.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Well once I learned how to detect the actual events surrounding those individuals that were coming to my website; the detection wasn’t limited to the billionaires and high-net-worth individuals. I could also use it to interpret which governmental agencies were visiting it most frequently, this included Governors, Senators, the president and various investigative and enforcement agencies. I think I explained that to you before we started.
				</p>
				<p class="h-l">
						H.L. Yes.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Often times when I would write to a billionaire in a foreign country they would be very interested; I would receive responses back or heavy traffic from that person.
				</p>
				<p class="h-l">
						H.L. Sure.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Then all of a sudden nothing! I mean I wouldn’t hear a single thing from them.  In a couple weeks then I would read in the news that this country just received a large grant package from the United States or a major aid package. And right then I knew what was going on.
				</p>
				<p class="h-l">
						H.L. That’s odd. So you’re implying that the government was sending out billions of dollars, whatever the aid packages were, to prevent them from donating to you?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, at first I didn’t believe it either. I would just tell myself this can’t be happening; certainly this is an overvaluation of your importance in the scheme of things.
				</p>
				<p class="h-l">
						H.L. Sure. This would be anyone’s reaction.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Still it kept happening, especially in regards to Africa. So to test the hypotheses, and to further refine the accuracy of the detection tool and technique I had developed, I put my hunch to the test.
						<span class="break"></span>
						I really don’t know why I did it, I had nothing to gain, and it wasn’t really like me. I found a country in Africa that I really wanted to visit one day, and had interest in. Then after sending the wealthiest individuals a copy of <span class="italic">The Legacy Letter</span>, I would essentially create a false narrative.
				</p>

				<p class="h-l">
						H.L. I don’t understand, what do you mean with a false narrative?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Well, and I only did this once, but I walked around our cabin and would tell my friends that I was sure that this individual was going to invest. I did this knowing we were being listened to the entire time, as the surveillance at this time was complete. I would even go so far as to look up an airline ticket to that country, knowing the government was monitoring all my searches.
				</p>
				<p class="h-l">
						H.L. But this individual billionaire in the country had no real interest that you could see?
				</p>
				<p>
						<span class="douglas">Douglas:</span> None; zero. But I didn’t stop there. I started acting as suspicious as possible. For example, to get to our basement you had to go outside and then around towards the bottom of the house. I would take the phone to the basement with me, which itself was out of my character. But I would also grab two or three spare cell phones that had long been out of commission. I made sure they were visible in my hand as I was walking out the front door. Again, really bizarre behavior, I suppose to get them to think I was talking to someone internationally on a phone they could not trace.
						<span class="break"></span>
						Of course, just as I had predicted, within a couple of weeks this country received a major aid package from the United States. So essentially there is a leader in an African Nation who was probably praising his good fortune, unknowing that it all originated from a deception tactic in rural Tennessee.
						<span class="break"></span>
						Again, I don’t know why I did that. It just wasn’t like anything I had done before, at least since I was a kid.
				</p>

				<p class="h-l">
						H.L. Maybe you just had enough.
				</p>
				<p>
						<span class="douglas">Douglas:</span> I think so. At that point things were deteriorating rapidly. I started to view those in D.C. with contempt and I am not a contemptuous individual. We were just sitting there like animals in the zoo; in a great big glass-paneled cage, in a beautiful but isolated place. I felt like a monkey in a cage. Well, this time the monkey fought back!
				</p>
				<p class="h-l">
						H.L. The irony being that you were so poor, yet you were either directly or indirectly responsible for allocating billions of dollars from the US to another country.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, we could barely afford a pack of cigarettes; so powerless and powerful at the same time. This pattern would follow me for years from that point. It is the strangest phenomena imaginable.
				</p>
				<p class="h-l">
						H.L. Because of the impeachment you mean?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Exactly. In fact that little move, me screwing with the president in that way, was likely responsible for much of the paranoia that he would experience later when he intensified the surveillance and began misinterpreting events in 2016. This misinterpretation would ultimately lead indirectly to the political scenario we all have endured since the election of our current president.
						<span class="break"></span>
						You see, the Obama Administration had studied me for well over six years by this time; this action, this little piece of rebellion, was completely out of my character. It didn’t fit my profile at all, so they didn’t know what to expect from me from there on out.
						<span class="break"></span>
						It just is all so bizarre.
				</p>

				<p class="h-l">
						H. L. You just couldn’t take it anymore. It makes sense. All the events were starting to add up.
				</p>
				<p>
						<span class="douglas">Douglas:</span> Yes, and don’t think I wasn’t punished for that little move either. Obama was like well, you want to screw around and play psychological games? I can do that too.
						<span class="break"></span>
						This of course was what he did, and this over a long period of time would cost me in a big way. But I do not want to go into details about what he did in return, as I need to protect the integrity of my friends who were with me at the time. But they were brutal, direct, debilitating and overarching to such an extent that I can’t believe I survived them. But I did.
						<span class="break"></span>
						There is just so much more I cannot talk about, so much; some just too painful. A lot more though, I can reveal, and I will, but the events were very traumatic up there.
				</p>

				<p class="h-l">
						H.L. I understand, it’s an abuse of power and it’s just not right.
						<span class="break"></span>
						So you were soon to leave Tennessee?
				</p>

				<p>
						<span class="douglas">Douglas:</span> Yes, things were really turning bad for us in the late fall of 2014. The money had all dried up; we were surrounded by a canopy of not only trees but also surveillance. A giant tree had even fallen onto our old pickup truck and just about cut it right down the middle. So we were on foot, and isolated.
						<span class="break"></span>
						We were absolutely broke. We had great landlords, but they were completely out of patience with me. I kept trying to keep them enthused, and updated. Everyone was waiting on the money to come. We were desperate. In two months we would be evicted, and out of Tennessee. If it was not for a substantial loan from a good friend and great man, we would not even have lasted that long. We were holding out for Christmas, at least December. I figured the giving season may save us. But it didn’t. We were in dire straits.
						<span class="break"></span>
						It would not be until summer of 2015, when I would reunite with my friends; not in Tennessee, but instead in Central Missouri. I had to go to work and make some money.
				</p>

				<p class="h-l">
						H.L. Do you want to talk about D.C. now?
				</p>
				<p>
						<span class="douglas">Douglas:</span> Tomorrow, we will pick this up in the morning.
				</p>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	components: {},
	methods: {
		nextPage() {
			window.scrollTo(0,0)
			this.$router.push('/day-two')
		}
	}
}
</script>

<style>

</style>